export default "__VITE_ASSET__DtLOf5Q$__"